import { render } from "./BalansirRules.vue?vue&type=template&id=557272a8&scoped=true"
import script from "./BalansirRules.vue?vue&type=script&lang=js"
export * from "./BalansirRules.vue?vue&type=script&lang=js"

import "./BalansirRules.vue?vue&type=style&index=0&id=557272a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-557272a8"]])

export default __exports__